/**
 * The Agents tab's top-level tabs, for every agent's cards:
 * - Needs decision: someone has to decide (accept, reject, act on a deal)
 * - In progress: accepted and waiting for its follow-up (Fiona for now)
 * - FYI: nothing to decide, only to read or mark as reviewed (Ross's
 *   analyses, Regina's alerts without a deal, what Iris already did, finished
 *   Fiona cards)
 */
import {
  decisionHasActiveDeal,
  getIrisPpcState,
  isDoneForYouDecision,
  isFionaDecision,
  isRossRevertDecision,
} from "../../constants";

import { getFionaTab, todayIso } from "./fiona/fionaRules";

export const RECOMMENDATION_TABS = [
  { key: "open", label: "Needs decision" },
  { key: "in_progress", label: "In progress" },
  { key: "fyi", label: "FYI" },
];

// Fiona's own lifecycle tab → the shared tab
const FIONA_TAB_TO_TAB = {
  review: "open",
  open: "in_progress",
  outcome: "fyi",
};

// "open", "in_progress", "fyi", or null for a card the dashboard doesn't show
export const getRecommendationTab = (decision, today = todayIso()) => {
  if (isFionaDecision(decision)) {
    return FIONA_TAB_TO_TAB[getFionaTab(decision, today)] || null;
  }
  // Iris is still pausing the ads: nothing to show until she's done
  if (getIrisPpcState(decision) === "pending") return null;
  if (isDoneForYouDecision(decision)) return "fyi";
  const agentName = decision?.decision?.agent?.toLowerCase() || "";
  const version = decision?.version || "";
  if (agentName === "regina" || version.includes("regina")) {
    // With Dave's deal attached it's a decision; alone it's an alert
    return decisionHasActiveDeal(decision) ? "open" : "fyi";
  }
  if (agentName === "ross" || version.includes("ross")) {
    // His price reverts can still need a manual action; his analyses can't
    return isRossRevertDecision(decision) ? "open" : "fyi";
  }
  return "open";
};
